<template>
  <div id="home" class="two-banner-wrap">
    <div class="two-banner-slider custom-slider" ref="viewport" @mouseenter="pause" @mouseleave="onMouseLeave">
      <!-- Track -->
      <div class="slider-track" :style="trackStyle" ref="track">
        <div class="slider-slide" v-for="slide in carouselItems" :key="slide.id">
          <div :class="slide.class">
            <div class="d-table">
              <div class="d-table-cell">
                <div class="container">
                  <div class="banner-content">
                    <span>
                      <img :src="slide.image" alt="Banner" />
                      {{ $t(slide.subTitle) }}
                    </span>
                    <h1>{{ $t(slide.heading) }}</h1>
                    <div class="banner-btn">
                      <a class="cmn-banner-btn" href="#service">
                        <i class="bx bx-note"></i>
                        {{ $t('banner.start') }}
                      </a>
                      <a class="banner-right-btn" href="#aboutus">
                        <i class="bx bx-note"></i>
                        {{ $t('banner.about') }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Nav -->
      <button class="slider-nav prev" @click="prev">‹</button>
      <button class="slider-nav next" @click="next">›</button>

      <div class="slider-dots">
        <button v-for="(s, i) in carouselItems" :key="i" class="dot" :class="{ active: i === currentIndex }"
          @click="goTo(i)" />
      </div>
    </div>

    <!-- Franja inferior -->
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6 p-0">
          <div class="banner-time-left">
            <ul>
              <li class="support-item">
                <a href="https://wa.me/34634061655" target="_blank" class="whatsapp-link">
                  <i class="bx bxl-whatsapp"></i>
                  <span>{{ $t('banner.support') }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-lg-6 p-0">
          <div class="banner-time-right">
            <ul>
              <li>
                <i class="bx bx-timer"></i>
                <span>{{ $t('banner.schedule') }}</span>
                <p>{{ $t('banner.hours') }}</p>
              </li>
              <li>
                <i class="bx bxs-contact"></i>
                <span>{{ $t('banner.contact') }}</span>
                <a href="mailto:contacto@Creativa360.es">contacto@creativa360.es</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainBanner',
  data() {
    return {
      currentIndex: 0,
      timer: null,
      autoplayMs: 5000,

      isDragging: false,
      startX: 0,
      deltaX: 0,
      thresholdPx: 60,

      carouselItems: [
        {
          id: 1,
          class: 'two-banner-area two-banner-one',
          image: require('../../assets/img/jill_icon.png'),
          subTitle: 'banner.slide1.sub',
          heading: 'banner.slide1.title',
        },
        {
          id: 2,
          class: 'two-banner-area two-banner-two',
          image: require('../../assets/img/jill_icon.png'),
          subTitle: 'banner.slide2.sub',
          heading: 'banner.slide2.title',
        },
        {
          id: 3,
          class: 'two-banner-area two-banner-three',
          image: require('../../assets/img/jill_icon.png'),
          subTitle: 'banner.slide3.sub',
          heading: 'banner.slide3.title',
        },
      ]
    };
  },

  computed: {
    trackStyle() {
      const base = -(this.currentIndex * 100);
      const dragPct = this.isDragging
        ? (this.deltaX / (this.$refs.viewport?.clientWidth || 1)) * 100
        : 0;

      return {
        transform: `translateX(calc(${base}% + ${dragPct}%))`,
        transition: this.isDragging ? 'none' : 'transform 0.6s ease',
      };
    },
  },

  mounted() {
    this.resume();
    window.addEventListener('resize', this.onResize, { passive: true });
  },

  beforeUnmount() {
    this.pause();
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.carouselItems.length;
    },

    prev() {
      this.currentIndex =
        (this.currentIndex - 1 + this.carouselItems.length) %
        this.carouselItems.length;
    },

    goTo(i) {
      this.currentIndex = i;
      this.restart();
    },

    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    resume() {
      if (!this.timer) {
        this.timer = setInterval(() => this.next(), this.autoplayMs);
      }
    },

    restart() {
      this.pause();
      this.resume();
    },

    onResize() {
      this.isDragging = false;
      this.deltaX = 0;
    },

    finishDrag() {
      const abs = Math.abs(this.deltaX);
      const dir = this.deltaX > 0 ? 'right' : 'left';
      this.isDragging = false;

      if (abs > this.thresholdPx) {
        dir === 'left' ? this.next() : this.prev();
      }

      this.deltaX = 0;
      this.resume();
    }
  },
};
</script>

<style scoped>
/* --- Evita deslizamientos laterales --- */
.two-banner-wrap {
  overflow-x: hidden;
}

.two-banner-wrap,
.two-banner-wrap * {
  box-sizing: border-box;
}

/* =======================
   Slider sin librería
   ======================= */
.custom-slider {
  position: relative;
  width: 100%;
  overflow: hidden;
  touch-action: pan-y;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.slider-track {
  display: flex;
  width: 100%;
  will-change: transform;
}

.slider-slide {
  flex: 0 0 100%;
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
}

/* Flechas */
.slider-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  background: rgba(0, 0, 0, 0.35);
  border: none;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  color: #fff;
  font-size: 22px;
  line-height: 38px;
  text-align: center;
  cursor: pointer;
  user-select: none;
}

.slider-nav.prev {
  left: 12px;
}

.slider-nav.next {
  right: 12px;
}

.slider-nav:focus {
  outline: 2px solid #fff;
}

/* Dots */
.slider-dots {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 12px;
  display: flex;
  justify-content: center;
  gap: 8px;
  z-index: 2;
}

.slider-dots .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 0;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
}

.slider-dots .dot.active {
  background: #fff;
}

/* --- Banner principal --- */
.two-banner-area {
  min-height: 64vh;
  display: flex;
  align-items: center;
  background-size: cover;
  background-position: center center;
}

.support-item {
  list-style: none;
  display: flex;
  align-items: center;
}

/* LINK */
.whatsapp-link {
  display: flex;
  align-items: center;   /* centra icono + texto entre sí */
  justify-content: center;
  gap: 10px;

  padding: 10px 16px;
  border-radius: 8px;

  background: rgba(37, 211, 102, 0.1);
  border: 1px solid rgba(37, 211, 102, 0.25);

  text-decoration: none;
  transition: all 0.25s ease;
}

/* ICONO */
.whatsapp-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  padding: 10px 16px;
  border-radius: 8px;

  background: rgba(37, 211, 102, 0.1);
  border: 1px solid rgba(37, 211, 102, 0.25);

  text-decoration: none;

  /* 🔥 IMPORTANTE */
  transform: none;
  transition: background 0.25s ease, box-shadow 0.25s ease;
}

/* ICONO estable */
.whatsapp-link i {
  font-size: 22px;
  color: #25D366 !important; /* 🔥 fuerza el verde */
  flex-shrink: 0;
}

/* TEXTO */
.whatsapp-link span {
  color: #fff;
  font-weight: 500;
  font-size: 15px;
  white-space: nowrap; /* 🔥 evita saltos raros */
}

/* HOVER PRO (SIN MOVER NADA) */
.whatsapp-link:hover {
  background: rgba(37, 211, 102, 0.18);
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.25);
}

/* --- Contenido del banner --- */
.banner-content {
  width: 100%;
  text-align: center;
}

.banner-content span {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  opacity: 0.9;
}

.banner-content h1 {
  margin: 10px 0 18px;
  font-weight: 800;
}

/* --- Botonera centrada --- */
.banner-btn {
  display: flex;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
}

.banner-btn .cmn-banner-btn,
.banner-btn .banner-right-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  padding: 12px 20px;
  line-height: 1;
}

/* --- Franja inferior (teléfono/horario) --- */
.two-banner-wrap>.container-fluid {
  width: 100%;
  max-width: 100%;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-top: 0 !important;
}

.banner-time-left,
.banner-time-right {
  width: 100%;
  height: 100%;
}

.banner-time-left ul {
  display: flex;
  justify-content: center;   /* centra horizontal */
  align-items: center;       /* centra vertical */
  height: 100%;
}

.banner-time-left ul li,
.banner-time-right ul li {
  list-style: none;
}

/* --- Responsive: móvil --- */
@media (max-width: 991px) {
  .two-banner-area {
    min-height: 72vh;
  }

  .banner-content h1 {
    font-size: 28px;
    line-height: 1.2;
  }

  .banner-content span img {
    width: 28px;
    height: auto;
  }

  .banner-time-left,
  .banner-time-right {
    text-align: center;
    padding: 18px 16px;
  }

  .slider-nav {
    width: 34px;
    height: 34px;
    font-size: 20px;
    line-height: 34px;
  }
}

/* --- Responsive: desktop --- */
@media (min-width: 992px) {
  .banner-content h1 {
    font-size: 64px;
    line-height: 1.1;
  }
}

/* --- Fix hueco en tablet --- */
@media (min-width: 768px) and (max-width: 1199px) {

  .two-banner-wrap,
  .two-banner-wrap .two-banner-slider,
  .two-banner-area,
  .two-banner-area .d-table,
  .two-banner-area .d-table-cell {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }

  .two-banner-area .d-table {
    min-height: 62vh;
  }

  .two-banner-wrap>.container-fluid {
    margin-top: -2px !important;
    padding-top: 0 !important;
  }
}

.slider-dots {
  display: none !important;
}
</style>
